module.exports = __webpack_public_path__ + "img/bo_concept_hero_billede_low.7f1277c1.jpg";